import axios from 'axios';
import type { IUser } from '@app/types';
import { API_PREFIX } from '@app/config';
import { OTHER_APP_HEADER, goToOtherApp } from '@app/core/utilities/getOtherAppUrl';

export async function fetchCurrentUser() {
  const response = await fetch(`${API_PREFIX}/tenant/user/get-current`);
  // The company is served by the other app (old and new app side by side): go there, as AxiosConfigProvider does.
  const otherApp = response.status === 409 ? response.headers.get(OTHER_APP_HEADER) : null;
  if (otherApp) {
    return goToOtherApp(otherApp, response.url);
  }

  if (response.status === 401) {
    return null;
  }

  if (response.status === 200) {
    return (await response.json()) as IUser;
  }
  throw new Error(`Unexpected response status: ${response.status}`);
}

export async function getCurrentUser() {
  return axios.get<IUser>('tenant/user/get-current');
}
export async function getUsers() {
  return axios.get<IUser[]>('users');
}
